import { X, File as FileIcon } from 'lucide-react';
import { FormikTextField } from '../../../../components/form-components/common-components/text-field/FormikTextField';
import { FormikDropdown } from '../../../../components/form-components/common-components/dropdown/FormikDropdown';
import { FormikFileUpload } from '../../../../components/form-components/common-components/file-upload/FormikFileUpload';
import type { IExpenseFileResult } from '../../../../models/expense/ExpenseModel';
import { expenseFieldIcons as EI } from './expenseFieldIcons';
import styles from './NewExpensePopup.module.css';

const STATUS_OPTIONS = [
  { value: 'Pending', label: 'Beklemede' },
  { value: 'Approved', label: 'Onaylandı' },
  { value: 'Rejected', label: 'Reddedildi' },
];

type ExpenseFormFieldsProps = {
  showStatus?: boolean;
  existingFiles?: IExpenseFileResult[];
  onRemoveExistingFile?: (fileId: number) => void;
  fileUploadLabel?: string;
};

const ExpenseFormFields = ({
  showStatus = false,
  existingFiles = [],
  onRemoveExistingFile,
  fileUploadLabel = 'Dosyalar (İsteğe Bağlı)',
}: ExpenseFormFieldsProps) => {
  const remainingFileSlots = Math.max(0, 3 - existingFiles.length);

  return (
    <>
      <div className={styles.formRow}>
        <div className={styles.inputContainer}>
          <FormikTextField
            name="amount"
            label="Miktar (₺)"
            type="text"
            inputMode="decimal"
            placeholder="0,00"
            disableUppercase
            startIcon={EI.amount}
          />
        </div>
        <div className={styles.inputContainer}>
          <FormikTextField
            name="expenseDate"
            label="Harcama Tarihi"
            type="date"
            startIcon={EI.expenseDate}
          />
        </div>
      </div>

      <div className={styles.inputContainer}>
        <FormikTextField
          name="description"
          label="Açıklama"
          placeholder="Harcama açıklamasını giriniz..."
          multiline
          rows={3}
          disableUppercase
          startIcon={EI.description}
        />
      </div>

      {showStatus ? (
        <div className={styles.inputContainer}>
          <FormikDropdown
            name="status"
            label="Durum"
            placeholder="Durum seçiniz"
            options={STATUS_OPTIONS}
            startIcon={EI.status}
          />
        </div>
      ) : null}

      {existingFiles.length > 0 ? (
        <div className={styles.inputContainer}>
          <span className={styles.fieldLabel}>Mevcut Dosyalar</span>
          <div className={styles.existingFilesList}>
            {existingFiles.map(file => (
              <div key={file.id} className={styles.existingFileItem}>
                <FileIcon size={16} className={styles.fileIcon} />
                <span className={styles.fileName} title={file.fileName}>
                  {file.fileName}
                </span>
                {onRemoveExistingFile ? (
                  <button
                    type="button"
                    className={styles.removeExistingFileButton}
                    onClick={() => onRemoveExistingFile(file.id)}
                    title="Kaldır"
                  >
                    <X size={16} />
                  </button>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      ) : null}

      <div className={styles.inputContainer}>
        <FormikFileUpload
          name="files"
          label={fileUploadLabel}
          placeholder="Dosya seçin veya buraya sürükleyin"
          accept=".pdf,.png,.jpeg,.jpg"
          multiple
          maxSize={2}
          maxFiles={remainingFileSlots || 3}
          allowedTypes={['pdf', 'png', 'jpeg', 'jpg']}
        />
        {existingFiles.length >= 3 ? (
          <p className={styles.fileHint}>
            Maksimum dosya sayısına ulaşıldı. Yeni dosya eklemek için mevcut dosyalardan birini
            kaldırın.
          </p>
        ) : null}
      </div>
    </>
  );
};

export default ExpenseFormFields;
